(function() {
    'use strict';
    angular
        .module('emarket.auth')
        .controller('RegisterController', ['$state', '$scope', '$stateParams', '$auth', '$mdToast', '$log', 'StateQueue', 'Auth', function($state,
            $scope,
            $stateParams,
            $auth,
            $mdToast,
            $log,
            StateQueue,
            Auth) {
            var vm = this;
            vm.signup = function(user) {
                vm.isLoading = true;
                vm.message = null;
                $auth
                    .signup(user)
                    .then(function(response) {
                        vm.loadingText = 'Correcto... espere';
                        vm.isLoading = false;
                        if (response.data.token && response.data.user) {
                            $auth.setToken(response.data.token);
                            Auth.setUser(response.data.user);
                        }
                        var state = StateQueue.getNext();
                        if (state.name === 'main.post.create') {
                            $state.go('main.profile.edit.phone', { location: 'replace' });
                        } else {
                            StateQueue.go({ bienvenido: 1 });
                        }
                    })
                    .catch(function(response) {
                        var err = response.data;
                        vm.isLoading = false;
                        var message = err && err.error ? err.error.message : 'Error inexperado';
                        $mdToast.show($mdToast
                            .simple()
                            .textContent(message)
                            .position('bottom right')
                            .hideDelay(3000));
                    });
            };
            // vm.validateUser = function () {
            //     console.log($scope);
            //     Auth.validateUsername(vm.user.username).then(function (exist) {
            //         vm.invalidUsername = exist;
            //         $scope.signupForm.$error['username'] = ''
            //     }).catch(function (err) {
            //         console.error(err);
            //     });
            // };
            //is validating
            if ($stateParams.token) {
                Auth
                    .validateToken($stateParams.token)
                    .then(function (res) {
                        if (res.$response.status === 202) {
                            $mdToast.show($mdToast
                                .simple()
                                .textContent('Bien ya has validado tu correo, ya puedes iniciar sesion')
                                .position('bottom right')
                                .hideDelay(3000));
                            $state.go('auth');
                        } else {
                            vm.isNewToken = true;
                        }
                    })
                    .catch(function (error) {
                        if (
                            error.$response.status === 400 ||
                            error.$response.status === 422
                        ) {
                            vm.errorMessage = error.$response.data.message;
                        }
                    });
            }
        }]);
}());
